import { useToggle } from "client/hooks/utils/useToggle";
import { HandleFile } from "client/types/HandleFile";
import { getImageExtension } from "client/utils/getImageExtension";
import { handleImageLoadedAnalytics } from "components/common/Uploader/UploadTypeSelector/useUploadTypeSelector";
import { useDispatch } from "react-redux";
import { resetSettings, setImage, setIsLoading, setUploadData } from "store/features/flipRotate/actions";

export const useUploadImage = () => {
    const dispatch = useDispatch();
    const { isOpen, toggle, onClose: close } = useToggle();

    const handleFile: HandleFile = async (files, upload, uploadSettings) => {
        const file = files[0];
        if (!file) return;
        dispatch(resetSettings());
        dispatch(
            setUploadData({
                type: upload,
                settings: uploadSettings,
            }),
        );
        dispatch(
            setImage({
                src: files[0].src,
                width: 0,
                height: 0,
                initialHeight: 0,
                initialWidth: 0,
                originalHeight: 0,
                originalWidth: 0,
                containerWidth: 0,
                containerHeight: 0,
                ratio: 1,
                title: file.file.name,
                ext: getImageExtension(file.file),
                // remaining values are arbitrary
                // they will be changed at usePreview
            }),
        );
    };

    const onUploadStart = () => {
        close();
        dispatch(setIsLoading(true));
    };

    const handleClick = () => {
        handleImageLoadedAnalytics({
            pageKey: "rotate_image",
            pageTitle: "Image Rotator",
        });
    };

    return {
        isOpen,
        toggle,
        close,
        handleFile,
        onUploadStart,
        handleClick,
    };
};
